// removed by extract-text-webpack-plugin
module.exports = {"base":"cms__Card__base","container":"cms__Card__container","rounded":"cms__Card__rounded","depth":"cms__Card__depth","card":"cms__Card__card cms__Card__base cms__Card__container cms__Card__rounded cms__Card__depth"};


//////////////////
// WEBPACK FOOTER
// ./components/UI/card/Card.css
// module id = 551
// module chunks = 0